// Gesetzliche Feiertage in Hessen — als Rechnung statt als Tabelle, damit kein Mensch
// jedes Jahr Daten nachpflegen muss.
//
// An einem Feiertag ist das Soll null: niemand rutscht dadurch ins Minus, und wer
// trotzdem arbeitet, sammelt die Zeit als Plus (Zuschlagsregeln folgen in Etappe 5).

/** Ostersonntag nach der Gaußschen Osterformel (gregorianisch). */
export function ostersonntag(jahr: number): Date {
  const a = jahr % 19;
  const b = Math.floor(jahr / 100);
  const c = jahr % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const monat = Math.floor((h + l - 7 * m + 114) / 31); // 3 = März, 4 = April
  const tag = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(jahr, monat - 1, tag));
}

const alsTag = (d: Date): string =>
  `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;

const plusTage = (d: Date, n: number): Date => new Date(d.getTime() + n * 24 * 60 * 60 * 1000);

/**
 * Alle gesetzlichen Feiertage eines Jahres in Hessen als { 'YYYY-MM-DD': Name }.
 * Hessen hat als einziges Bundesland Fronleichnam ohne Allerheiligen/Reformationstag.
 */
export function feiertageHessen(jahr: number): Record<string, string> {
  const o = ostersonntag(jahr);
  const feste: [string, string][] = [
    [`${jahr}-01-01`, 'Neujahr'],
    [`${jahr}-05-01`, 'Tag der Arbeit'],
    [`${jahr}-10-03`, 'Tag der Deutschen Einheit'],
    [`${jahr}-12-25`, '1. Weihnachtstag'],
    [`${jahr}-12-26`, '2. Weihnachtstag'],
  ];
  const beweglich: [string, string][] = [
    [alsTag(plusTage(o, -2)), 'Karfreitag'],
    [alsTag(o), 'Ostersonntag'],
    [alsTag(plusTage(o, 1)), 'Ostermontag'],
    [alsTag(plusTage(o, 39)), 'Christi Himmelfahrt'],
    [alsTag(plusTage(o, 49)), 'Pfingstsonntag'],
    [alsTag(plusTage(o, 50)), 'Pfingstmontag'],
    [alsTag(plusTage(o, 60)), 'Fronleichnam'],
  ];
  return Object.fromEntries([...feste, ...beweglich]);
}

const zwischenspeicher = new Map<number, Record<string, string>>();

/** Name des Feiertags oder null. Ergebnisse werden je Jahr gemerkt. */
export function feiertagName(tag: string): string | null {
  const jahr = Number(tag.slice(0, 4));
  if (!jahr) return null;
  if (!zwischenspeicher.has(jahr)) zwischenspeicher.set(jahr, feiertageHessen(jahr));
  return zwischenspeicher.get(jahr)![tag] || null;
}

export function istFeiertag(tag: string): boolean {
  return feiertagName(tag) !== null;
}
